import { render, staticRenderFns } from "./cashierList.vue?vue&type=template&id=2c84a90f&scoped=true&"
import script from "./cashierList.vue?vue&type=script&lang=js&"
export * from "./cashierList.vue?vue&type=script&lang=js&"
import style0 from "./cashierList.vue?vue&type=style&index=0&id=2c84a90f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84a90f",
  null
  
)

export default component.exports